import { render, staticRenderFns } from "./itemOptions.vue?vue&type=template&id=038ab508&scoped=true&"
import script from "./itemOptions.vue?vue&type=script&lang=js&"
export * from "./itemOptions.vue?vue&type=script&lang=js&"
import style0 from "./itemOptions.vue?vue&type=style&index=0&id=038ab508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ab508",
  null
  
)

export default component.exports